/**
 * HierarchySelector Component
 * 
 * Extracted from HierarchyStep - handles the cascade selection:
 * Hall → Line → Subline → Component → Task
 * 
 * This is a PRESENTATIONAL component that receives all options via props.
 */
import React from 'react';

export default function HierarchySelector({
    // Current values
    hall = '',
    line = '',
    subline = '',
    component = '',
    task = '',

    // Available options
    halls = [],
    lines = [],
    sublines = [],
    components = [],
    tasks = [],

    // Doc links
    sublineDocLink = '',
    sublineDocLinkElectro = '',
    sublineDocLinkManual = '',
    componentDocLink = '',
    instanceName = '',

    // Callbacks
    onChange,  // (field, value) => void

    // Helper
    filterSystemKeys = (keys) => keys.filter(k => !['lines', 'sublines', 'halls', 'id', 'name', 'type'].includes(k) && !k.startsWith('_'))
}) {
    return (
        <div className="space-y-4">
            {/* Hal */}
            <div>
                <label className="label">Hal</label>
                <select
                    className="input glass-input"
                    value={hall}
                    onChange={(e) => onChange('hall', e.target.value)}
                >
                    <option value="" className="bg-slate-800">Selecteer Hal...</option>
                    {filterSystemKeys(halls).map(h => (
                        <option key={h} value={h} className="bg-slate-800">{h}</option>
                    ))}
                </select>
            </div>

            {/* Lijn */}
            <div>
                <label className="label">Lijn</label>
                <select
                    className="input glass-input"
                    value={line}
                    onChange={(e) => onChange('line', e.target.value)}
                    disabled={!hall}
                >
                    <option value="" className="bg-slate-800">Selecteer Lijn...</option>
                    {filterSystemKeys(lines).map(l => (
                        <option key={l} value={l} className="bg-slate-800">{l}</option>
                    ))}
                </select>
            </div>

            {/* Deel Lijn */}
            <div>
                <div className="flex justify-between items-center mb-1">
                    <label className="label mb-0">Deel Lijn</label>
                    <div className="flex gap-2">
                        {sublineDocLink && (
                            <a
                                href={sublineDocLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-xs text-blue-400 hover:text-blue-300 flex items-center gap-1"
                                title="Technische Tekeningen"
                            >
                                📐 Tech
                            </a>
                        )}
                        {sublineDocLinkElectro && (
                            <a
                                href={sublineDocLinkElectro}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-xs text-yellow-500 hover:text-yellow-400 flex items-center gap-1"
                                title="Elektro Tekeningen"
                            >
                                ⚡ Elektro
                            </a>
                        )}
                        {sublineDocLinkManual && (
                            <a
                                href={sublineDocLinkManual}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-xs text-green-400 hover:text-green-300 flex items-center gap-1"
                                title="Handleidingen"
                            >
                                📘 Handl.
                            </a>
                        )}
                    </div>
                </div>
                <select
                    className="input glass-input"
                    value={subline}
                    onChange={(e) => onChange('subline', e.target.value)}
                    disabled={!line}
                >
                    <option value="" className="bg-slate-800">Selecteer Deel Lijn...</option>
                    {sublines.map(sl => (
                        <option key={sl} value={sl} className="bg-slate-800">{sl}</option>
                    ))}
                </select>
            </div>

            {/* Onderdeel */}
            <div>
                <div className="flex justify-between items-center mb-1">
                    <label className="label mb-0">
                        Onderdeel{' '}
                        {instanceName && (
                            <span className="ml-2 text-blue-400 font-bold text-xs uppercase bg-blue-900/40 px-2 py-0.5 rounded border border-blue-800">
                                {instanceName}
                            </span>
                        )}
                    </label>
                    {componentDocLink && (
                        <a
                            href={componentDocLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-xs text-purple-400 hover:text-purple-300 flex items-center gap-1"
                            title="Component Documentatie"
                        >
                            📋 Docs
                        </a>
                    )}
                </div>
                <select
                    className="input glass-input"
                    value={component}
                    onChange={(e) => onChange('component', e.target.value)}
                    disabled={!subline}
                >
                    <option value="" className="bg-slate-800">Selecteer Onderdeel...</option>
                    {components.map(c => (
                        <option key={c} value={c} className="bg-slate-800">{c}</option>
                    ))}
                </select>
            </div>

            {/* Taak */}
            <div>
                <label className="label">Taak</label>
                <select
                    className="input glass-input"
                    value={task}
                    onChange={(e) => onChange('task', e.target.value)}
                    disabled={!component}
                >
                    <option value="" className="bg-slate-800">Selecteer Taak...</option>
                    {tasks.map(t => (
                        <option key={t} value={t} className="bg-slate-800">{t}</option>
                    ))}
                </select>
            </div>
        </div>
    );
}
